import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash/get';

import BreadCrumbs from 'yoda-core-components/lib/components/BreadCrumbs/BreadCrumbs';
import Crumbs from 'yoda-core-components/lib/components/BreadCrumbs/BreadCrumbs/Crumbs';
import { selectFeatureFlags } from '../../selectors/ContextSelector';
import analyticsAction from '../../actions/AnalyticsAction';

export const saveAnalyticsData = (
    actions,
    totalnumber,
    clickedCrumbPosition,
    difference,
    breadCrumbs
) =>
    /* istanbul ignore next */
    actions.saveBreadCrumbData({
        totalnumber,
        clickedCrumbPosition,
        difference,
        breadCrumbs,
    });

const renderCrumbs = (breadCrumbs, softRoute) => {
    let newSoftRoute = false;
    return breadCrumbs.map((crumbs, index) => {
        let crumbsHtml;
        newSoftRoute = index === 0 ? false : softRoute;
        if (index !== breadCrumbs.length - 1 && crumbs && crumbs.navigationState) {
            crumbsHtml = (
                <Crumbs
                    key={index.toString()}
                    softRoute={newSoftRoute}
                    path={crumbs.navigationState}
                >
                    {crumbs.breadCrumbLabel}
                </Crumbs>
            );
        } else {
            crumbsHtml = (
                <Crumbs key={index.toString()} softRoute={softRoute} isActive>
                    {crumbs.breadCrumbLabel}
                </Crumbs>
            );
        }

        return crumbsHtml;
    });
};

const renderBreadCrumbs = (
    breadCrumbs,
    minLengthOfCrums,
    showJCPenneyCrumb,
    softRoute,
    actions,
    featureFlags,
    isNative
) => {
    const breadCrumbsToRender = [...breadCrumbs];
    const { enableBreadcrumbsUnderlineChevron = true } = featureFlags;
    if (!showJCPenneyCrumb && breadCrumbs[0].breadCrumbLabel === 'JCPenney') {
        breadCrumbsToRender.splice(0, 1);
    }

    let separator = 'slashGrayTheme';
    if (enableBreadcrumbsUnderlineChevron) {
        separator = 'arrow';
    }

    if (!isNative && breadCrumbsToRender && breadCrumbsToRender.length > minLengthOfCrums) {
        return (
            <BreadCrumbs
                separator={separator}
                saveBreadCrumbAnalytics={
                    /* istanbul ignore next */
                    (...props) => saveAnalyticsData(actions, ...props)
                }
            >
                {renderCrumbs(breadCrumbsToRender, softRoute)}
            </BreadCrumbs>
        );
    }
    return null;
};

export const BreadCrumb = ({
    breadCrumbs,
    minLengthOfCrums,
    showJCPenneyCrumb,
    softRoute,
    actions,
    featureFlags,
    isNative,
}) =>
    renderBreadCrumbs(
        breadCrumbs,
        minLengthOfCrums,
        showJCPenneyCrumb,
        softRoute,
        actions,
        featureFlags,
        isNative
    );

BreadCrumb.propTypes = {
    breadCrumbs: PropTypes.arrayOf(PropTypes.object),
    softRoute: PropTypes.bool,
    minLengthOfCrums: PropTypes.number,
    showJCPenneyCrumb: PropTypes.bool,
    actions: PropTypes.object,
    isNative: PropTypes.bool,
};

BreadCrumb.defaultProps = {
    breadCrumbs: [],
    softRoute: false,
    minLengthOfCrums: 0,
    showJCPenneyCrumb: true,
    actions: {},
    isNative: false,
};

const mapStateToProps = (state) => ({
    featureFlags: selectFeatureFlags(state),
    isNative: _get(state.context, 'isNative', false),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(analyticsAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BreadCrumb);
